module.exports = __webpack_public_path__ + "img/photo-0063.6a67889c.jpg";